import policy from '../config/account-storage.json' with {type: 'json'};

const planLimits = Object.values(policy.newAccounts.planLimitBytes);
export const ACCOUNT_STORAGE_LABEL = `${Math.min(...planLimits) / 1_000_000_000}–${Math.max(...planLimits) / 1_000_000_000} GB`;

/** account-storage.json owns the storage sizes offered to new registrations. */
export function subscriptionPlanStorageBytes(planKey: string): number {
  const plans: Readonly<Record<string, number>> = policy.newAccounts.planLimitBytes;
  const bytes = Object.hasOwn(plans, planKey) ? plans[planKey] : undefined;
  if (bytes === undefined || !Number.isSafeInteger(bytes) || bytes <= 0) {
    throw new Error(`No storage allocation is configured for subscription plan: ${planKey}`);
  }
  return bytes;
}
